import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { DatasourceTableJobStore } from '@y42/datasource';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'sql-modeling-table-job', idKey: 'request_id' })
export class SqlModelingTableJobStore extends DatasourceTableJobStore {
  constructor() {
    super();
  }
}
